var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.pageContent)?_c('div',[_c('default-layout',{attrs:{"nav-bar-variant":_vm.pageContent.NavBarVariant}},[_c('content-block-list',{attrs:{"blocks":_vm.pageContent.body}})],1)],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }